export default __webpack_public_path__ + "static/media/right_head_arrow.d2172600.svg";